import { Fragment, useEffect, useState } from "react"
import { getToday } from "../../utils"
import {
  Button,
  Flex,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
} from "@chakra-ui/react"

import FormField from "../Common/FormField"
import ProductSelect from "./ProductSelect"

const iso = (dt) => dt.toISOString().substring(0, 10)

const LinkForm = ({
  title,
  item,
  isLoading,
  onSubmit,
  onRemove,
  modalController,
}) => {
  const [name, setName] = useState(item?.name || "")
  const [startDate, setStartDate] = useState(item?.startDate || getToday())
  const [endDate, setEndDate] = useState(item?.endDate || getToday())
  const [selectedProducts, setSelectedProducts] = useState(
    item?.selectedProducts || []
  )

  const onSave = () => {
    onSubmit({
      active: true,
      name,
      startDate,
      endDate,
      selectedProducts,
    })
    modalController.onClose()
  }

  useEffect(() => {
    setName(item?.name || "")
    setStartDate(item?.startDate.toDate() || getToday())
    setEndDate(item?.endDate.toDate() || getToday())
    setSelectedProducts(item?.selectedProducts || [])
  }, [item])

  return (
    <Fragment>
      <Modal
        size="4xl"
        isOpen={modalController.isOpen}
        onClose={modalController.onClose}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{title}</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            <Stack spacing={4}>
              <FormField label="Nome (facoltativo)">
                <Input
                  size="md"
                  value={name}
                  onChange={(event) => setName(event.target.value)}
                />
              </FormField>
              <Stack direction="row" spacing={4}>
                <FormField label="Apertura" isRequired>
                  <Input
                    type="date"
                    size="md"
                    value={iso(startDate)}
                    onChange={(event) =>
                      setStartDate(new Date(event.target.valueAsNumber))
                    }
                  />
                </FormField>
                <FormField label="Chiusura" isRequired>
                  <Input
                    type="date"
                    size="md"
                    value={iso(endDate)}
                    onChange={(event) =>
                      setEndDate(new Date(event.target.valueAsNumber))
                    }
                  />
                </FormField>
              </Stack>
              <FormField label="Prodotti">
                <ProductSelect
                  selected={selectedProducts}
                  setSelected={setSelectedProducts}
                />
              </FormField>
            </Stack>
          </ModalBody>

          <ModalFooter>
            <Flex justify="space-between" w="full">
              {item ? (
                <Button
                  isLoading={false}
                  onClick={() => {
                    onRemove(item.id)
                    modalController.onClose()
                  }}
                  colorScheme="red"
                  mr={3}
                >
                  Rimuovi
                </Button>
              ) : (
                <span></span>
              )}
              <Button
                isLoading={isLoading}
                onClick={onSave}
                colorScheme="teal"
                mr={3}
              >
                Salva
              </Button>
            </Flex>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Fragment>
  )
}

export default LinkForm
